module.exports = __webpack_public_path__ + "static/img/bg-gems.1f58ccc6.webp";